import { NetworkError } from './network-error'

type NetworkErrorListener = (error: NetworkError) => void

/**
 * Pub-sub mínimo para erros de rede. Ponte entre a camada infra (query-client,
 * que centraliza o onError do React Query) e a UI global (NetworkErrorSnackbar),
 * sem que a infra dependa da presentation. Só é alimentado com NetworkError —
 * que, por sua vez, só é lançado com a feature flag ligada.
 */
const listeners = new Set<NetworkErrorListener>()

/** Inscreve um listener; retorna a função de cancelamento da inscrição. */
export const onNetworkError = (listener: NetworkErrorListener): (() => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** Notifica todos os listeners inscritos sobre um NetworkError. */
export const emitNetworkError = (error: NetworkError): void => {
  listeners.forEach(listener => listener(error))
}
